import type {
  OrderError,
  OrderItemFulfilmentDetails,
} from '@skupreme/api-contracts/core';
import { SP_ORDER_PREFIX } from '@utility/constants/common';
import { getLabelIssue } from './issues';

/* An order line seen only through the fulfillment records it carries. */
export type FulfillmentRecordItem = {
  fulfilment_details?: OrderItemFulfilmentDetails[];
};

/**
 * The provider's own id for the order. Whose id it is is read off the status
 * prefix — `FBA_SHIPPED`, `DELIVERR_CREATED` — since an order can hold both.
 */
export function getFulfillmentOrderId(
  items: FulfillmentRecordItem[] | undefined,
  isFBA: boolean,
): string {
  const prefix = isFBA ? 'FBA' : 'DELIVERR';

  for (const item of items || []) {
    for (const detail of item.fulfilment_details || []) {
      if (
        detail.fulfilment_order_id &&
        detail.fulfillment_order_status?.startsWith(prefix)
      ) {
        return detail.fulfilment_order_id;
      }
    }
  }

  return '';
}

/** Fulfillment ids are shown prefixed, and some already arrive that way. */
export function withOrderPrefix(value: string): string {
  return value.startsWith(SP_ORDER_PREFIX)
    ? value
    : `${SP_ORDER_PREFIX}${value}`;
}

/** The carrier's self-service link, recorded as the label error's detail. */
export function getPublicLabelLink(
  errors: OrderError[] | undefined,
): string | undefined {
  return getLabelIssue(errors)?.error_details;
}
